/**
 * Re-read server game state when a player comes back.
 * Covers tab focus, bfcache restore, and the network returning.
 * Socket reconnect should still fetch explicitly in the connect handler.
 */
export function bindGameResync(resync, { debounceMs = 350 } = {}) {
  if (typeof window === "undefined" || typeof resync !== "function") {
    return () => {};
  }

  let timer = null;
  const schedule = () => {
    if (typeof document !== "undefined" && document.visibilityState === "hidden") return;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      Promise.resolve()
        .then(() => resync())
        .catch((err) => {
          console.warn("[game-resync]", err);
        });
    }, debounceMs);
  };

  const onVisible = () => {
    if (document.visibilityState === "visible") schedule();
  };
  const onPageShow = (event) => {
    if (event.persisted) schedule();
  };

  document.addEventListener("visibilitychange", onVisible);
  window.addEventListener("pageshow", onPageShow);
  window.addEventListener("online", schedule);

  return () => {
    if (timer) clearTimeout(timer);
    document.removeEventListener("visibilitychange", onVisible);
    window.removeEventListener("pageshow", onPageShow);
    window.removeEventListener("online", schedule);
  };
}
